import { GRUPOS } from "@/components/configuracion/secciones";

/**
 * Navegación de Configuración.
 *
 * Dos formas de la misma lista: `lateral` acompaña al contenido en tablet y
 * escritorio, `lista` es la primera pantalla en móvil y lleva a la sección.
 *
 * Sin iconos a propósito: diecisiete secciones en pictogramas obligan a
 * adivinar cuál es cuál, y el texto cabe.
 */
export default function MenuConfig({
  actual,
  onElegir,
  variante,
}: {
  actual: string | null;
  onElegir: (id: string) => void;
  variante: "lateral" | "lista";
}) {
  const esLista = variante === "lista";

  return (
    <nav aria-label="Secciones de configuración" className={esLista ? "space-y-5" : "space-y-4"}>
      {GRUPOS.map((grupo) => (
        <div key={grupo.titulo}>
          <h2 className="px-2 text-[10px] uppercase tracking-wide text-zinc-500">{grupo.titulo}</h2>
          <ul className="mt-1 space-y-px">
            {grupo.secciones.map((seccion) => {
              const activa = !esLista && seccion.id === actual;
              return (
                <li key={seccion.id}>
                  <button
                    type="button"
                    onClick={() => onElegir(seccion.id)}
                    aria-current={activa ? "page" : undefined}
                    className={[
                      "flex w-full items-center justify-between gap-2 border-l-2 text-left",
                      "transition-colors focus-visible:outline-none focus-visible:ring-1",
                      "focus-visible:ring-accent-500",
                      esLista ? "rounded px-3 py-3 text-sm" : "rounded-r px-2 py-1.5 text-sm",
                      activa
                        ? "border-accent-500 bg-ink-800 text-accent-400"
                        : "border-transparent text-zinc-400 hover:bg-ink-800/60 hover:text-white",
                    ].join(" ")}
                  >
                    <span>{seccion.titulo}</span>
                    {esLista && (
                      <span aria-hidden className="text-zinc-600">
                        ›
                      </span>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
